import React, { useEffect } from 'react';
import PageHeader from '../components/HeroSection';
import BookSection from '../components/BookSection';
import WorkSchedule from '../components/WorkSchedule';
import ContactBackgrounddamask from '../assets/images/White_damask.webp';
import Facebook from '../assets/images/facebook.png';
import Instagram from '../assets/images/Insta_Icon.png';
import Tiktok from '../assets/images/tiktok-icon.png';
import { Helmet } from 'react-helmet';
const ContactPage = () => {
  // Initialize Leaflet map
  useEffect(() => {
    // Load Leaflet CSS
    if (!document.querySelector('link[href*="leaflet.css"]')) {
      const leafletCSS = document.createElement('link');
      leafletCSS.rel = 'stylesheet';
      leafletCSS.href = 'https://unpkg.com/leaflet/dist/leaflet.css';
      document.head.appendChild(leafletCSS);
    }

    // Load Leaflet JS
    const loadLeaflet = () => {
      if (!window.L) {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/leaflet/dist/leaflet.js';
        script.onload = () => {
          initMap();
        };
        document.body.appendChild(script);
      } else {
        initMap();
      }
    };

    const initMap = () => {
      const mapElement = document.getElementById('contact-map');
      if (!mapElement || !window.L) return;

      // Check if map is already initialized
      if (mapElement._leaflet_id) {
        return;
      }

      try {
        // Initialize map at Easton, PA
        const L = window.L;
        const map = L.map('contact-map').setView([40.69, -75.21], 13);

        // Light/Minimal map (Carto Light, free)
        const lightMap = L.tileLayer(
          'https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/">CARTO</a>',
            subdomains: 'abcd',
            maxZoom: 19
        });

        // Satellite map (ESRI free tiles)
        const satelliteMap = L.tileLayer(
          'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
            attribution: 'Tiles &copy; <a href="https://www.esri.com/">Esri</a>'
        });

        // Add default layer
        lightMap.addTo(map);

        // Black marker icon
        const blackIcon = L.icon({
          iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png",
          shadowUrl: "https://unpkg.com/leaflet/dist/images/marker-shadow.png",
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41]
        });

        // Marker at exact location
        L.marker([40.6889, -75.2096], {icon: blackIcon}).addTo(map)
          .bindPopup("Hair To Dye For<br>200 Northampton St, Easton, PA 18042")
          .openPopup();

        // Layer control (Map / Satellite)
        const baseMaps = {
          "Map": lightMap,
          "Satellite": satelliteMap
        };
        L.control.layers(baseMaps).addTo(map);

        // Store map instance for cleanup
        mapElement._leafletMap = map;
      } catch (error) {
        console.error('Error initializing map:', error);
      }
    };

    // Load Leaflet after a small delay to ensure DOM is ready
    setTimeout(loadLeaflet, 100);

    // Cleanup function
    return () => {
      const mapElement = document.getElementById('contact-map');
      if (mapElement && mapElement._leafletMap) {
        try {
          mapElement._leafletMap.remove();
          delete mapElement._leafletMap;
        } catch (error) {
          console.error('Error cleaning up map:', error);
        }
      }
    };
  }, []);

  // Reusable font styles
  const fontStyles = {
    quentin: {
      fontFamily: 'Quentin',
      fontWeight: 400,
      fontStyle: 'Regular',
      lineHeight: '100%',
      letterSpacing: '0%',
      textAlign: 'center'
    },
    subtitle: {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontStyle: 'Regular',
      lineHeight: '100%',
      letterSpacing: '0.2em',
      textAlign: 'center',
      textTransform: 'uppercase'
    },
    mainHeading: {
      fontFamily: 'Montserrat',
      fontWeight: 700,
      fontStyle: 'Bold',
      lineHeight: '100%',
      letterSpacing: '0.04em',
      textAlign: 'center',
      textTransform: 'uppercase',
      color: '#000000'
    },
    workingText: {
      fontFamily: 'Montserrat',
      fontWeight: 700,
      textAlign: 'left',
      fontSize: '20px',
      lineHeight: '100%',
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
      color: '#000000'
    },
    dayText: {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '156%',
      color: '#6B6B6B'
    },
    phoneTextNew: {
      fontFamily: 'Montserrat',
      fontWeight: 200,
      textAlign: 'right',
      fontSize: '20px',
      lineHeight: '100%',
      color: '#000000'
    },
     phoneText: {
      fontFamily: 'Montserrat',
      fontWeight: 700,
      fontSize: '20px',
      lineHeight: '100%',
      color: '#000000'
    },
    addressText: {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: '20px',
      lineHeight: '176%',
      letterSpacing: '0em',
      textAlign: 'center',
      color: '#1D1D1D'
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
  <title>Contact Hair to Dye For | Easton, PA Salon</title>
  <meta name="description" content="Call 610-923-3530 or visit us in downtown Easton to schedule your next hair appointment. Hair to Dye For specializes in custom looks." />
  <meta property="og:title" content="Contact Our Salon | Hair to Dye For – Easton, PA" />
  <meta property="og:description" content="Reach out to Hair to Dye For for hair extension consultations, color appointments, or general inquiries." />
  <meta property="og:url" content="https://www.hairtodyeforeaston.com/contact" />
  <meta property="og:type" content="website" />
  <meta name="keywords" content="contact hair salon Easton PA, book hair appointment Easton, hair extension consultation, 610-923-3530" />
  <link rel="canonical" href="https://www.hairtodyeforeaston.com/contact" />
</Helmet>
      {/* Page Header with Hero */}
      <PageHeader pageTitle="CONTACT US" />

      <section className="min-h-[600px] lg:h-[1008px]">
  <div className="h-full grid grid-cols-1 lg:grid-cols-2">
    <h1 className="sr-only">Book Your Appointment at Hair to Dye For</h1>
    {/* Left Side - Interactive Map */}
    <div className="w-full h-[400px] lg:h-[1008px] order-2 lg:order-1">
      <div id="contact-map" className="w-full h-full"></div>
    </div>
    
    {/* Right Side - Contact Information */}
    <div 
      className="w-full min-h-[600px] lg:h-[1008px] flex items-center justify-center p-6 sm:p-8 lg:p-16 relative order-1 lg:order-2"
      style={{
        backgroundImage: `url(${ContactBackgrounddamask})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="w-full max-w-[832px] mx-auto relative">
        {/* Location heading with overlaid EASTON • SINCE 2005 */}
        <div className="relative mb-8">
          {/* Background "Location" text */}
          <div className="flex items-center justify-center">
            <h2 style={{
              ...fontStyles.quentin,
              fontSize: 'clamp(80px, 15vw, 160px)',
              color: '#F2EADC',
              opacity: 0.5
            }}>Location</h2>
          </div>
          
          {/* EASTON • SINCE 2005 overlaid on Location */}
          <p className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" 
            style={{
              ...fontStyles.subtitle,
              fontSize: 'clamp(12px, 2vw, 16px)'
            }}>
            EASTON • SINCE 2005
          </p>
        </div>
        
        {/* Content Container */}
        <div className="relative z-10 text-center">
          {/* Main Heading */}
          <h3 className="mb-8 lg:mb-16" style={{
            ...fontStyles.mainHeading,
            fontSize: 'clamp(28px, 5vw, 40px)'
          }}>CONTACT US</h3>
          
          {/* Work Schedule */}
          <WorkSchedule />

            {/* Weekend Section */}
            {/* <div>
              <div className="flex justify-between items-baseline mb-2">
                <h4 style={fontStyles.workingText}>WEEKEND</h4>
                <span style={fontStyles.phoneTextNew}>10AM - 6PM</span>
              </div>
              <div className="border-b border-gray-300 mb-2"></div>
              <p className="text-left" style={fontStyles.dayText}>Saturday, Sunday</p>
            </div> */}
         
          
          {/* Phone and Address */}
          <div className="mb-8 lg:mb-12">
            <p className="mb-4" style={fontStyles.phoneText}>
              <a href="tel:+16109233530" className="hover:opacity-80 transition-opacity">
                1 (610) 923-3530
              </a>
            </p>
            <div className="w-48 sm:w-64 h-px mx-auto mb-4" style={{ backgroundColor: '#D4D4D4' }}></div>
            <p style={fontStyles.addressText}>
              200 Northampton St, Easton, PA 18042
            </p>
          </div>
          
          {/* Social Icons */}
          <div className="text-center">
            <div className="flex justify-center space-x-6 mb-6">
              <button 
                onClick={() => window.open('https://www.facebook.com/h2d4easton', '_blank', 'noopener,noreferrer')}
                className="w-10 h-10 sm:w-12 sm:h-12 bg-[#F2EADC] rounded-full flex items-center justify-center hover:bg-[#E8DCC4] transition-colors shadow-lg"
                aria-label="Visit our Facebook page"
              >
                <img src={Facebook} alt="Facebook" className="w-10 h-10 sm:w-12 sm:h-12" />
              </button>
              <button 
                onClick={() => window.open('https://www.instagram.com/h2d4easton/', '_blank', 'noopener,noreferrer')}
                className="w-10 h-10 sm:w-12 sm:h-12 bg-[#F2EADC] rounded-full flex items-center justify-center hover:bg-[#E8DCC4] transition-colors shadow-lg"
                aria-label="Visit our Instagram page"
              >
                <img src={Instagram} alt="Instagram" className="w-10 h-10 sm:w-12 sm:h-12" />
              </button>
              <button 
                    onClick={() => window.open('https://www.tiktok.com/@h2d4easton', '_blank', 'noopener,noreferrer')}
                    className="w-10 h-10 sm:w-12 sm:h-12 bg-[#F2EADC] rounded-full flex items-center justify-center hover:bg-[#E8DCC4] transition-colors shadow-lg"
                    aria-label="Visit our Instagram page"
                  >
                    <img src={Tiktok} alt="Tiktok" className="w-10 h-10 sm:w-12 sm:h-12" />
                  </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* Book Section */}
      <BookSection />
    </div>
  );
};

export default ContactPage;